

interface IShorts {
  url: string
}

const YouTubeShortsEmbed = (props: IShorts) => {
 
  return (
    <div className="">
      <iframe
        width="350px"
        height="675px"
        src={props.url}
        title="YouTube Shorts"
        frameBorder="0"
        allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
  </div>
  )
}


export default YouTubeShortsEmbed;